import { FC } from 'react'

import { ISvgClass } from '../interface'

const SearchIcon: FC<ISvgClass> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M19.2614 20.7183L13.5341 14.9829C13.0227 15.3926 12.4347 15.7169 11.7699 15.9559C11.1051 16.1949 10.3977 16.3144 9.64773 16.3144C7.78977 16.3144 6.2175 15.6702 4.93091 14.3817C3.64364 13.0926 3 11.5178 3 9.65718C3 7.79659 3.64364 6.22174 4.93091 4.93263C6.2175 3.64421 7.78977 3 9.64773 3C11.5057 3 13.0783 3.64421 14.3656 4.93263C15.6522 6.22174 16.2955 7.79659 16.2955 9.65718C16.2955 10.4083 16.1761 11.1166 15.9375 11.7824C15.6989 12.4481 15.375 13.037 14.9659 13.5491L20.7188 19.3101C20.9063 19.4979 21 19.7283 21 20.0014C21 20.2745 20.8977 20.5135 20.6932 20.7183C20.5057 20.9061 20.267 21 19.9773 21C19.6875 21 19.4489 20.9061 19.2614 20.7183ZM9.64773 14.266C10.9261 14.266 12.013 13.8181 12.9082 12.9223C13.8027 12.0258 14.25 10.9374 14.25 9.65718C14.25 8.37696 13.8027 7.28859 12.9082 6.39209C12.013 5.49627 10.9261 5.04836 9.64773 5.04836C8.36932 5.04836 7.2825 5.49627 6.38727 6.39209C5.49273 7.28859 5.04545 8.37696 5.04545 9.65718C5.04545 10.9374 5.49273 12.0258 6.38727 12.9223C7.2825 13.8181 8.36932 14.266 9.64773 14.266Z"
        fill="inherit"
      />
    </svg>
  )
}

export default SearchIcon
